import { render, staticRenderFns } from "./TheCards.vue?vue&type=template&id=d7c9f71e&scoped=true"
import script from "./TheCards.vue?vue&type=script&lang=js"
export * from "./TheCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c9f71e",
  null
  
)

export default component.exports